/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestsListComponent } from './requests/requests-list/requests-list.component';
import { RequestsFormComponent } from './requests/requests-form/requests-form.component';
import { SharedModule } from '@app/shared';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { RequestsService } from '@app/sales/requests/requests.service';
import { RequestsFormService } from '@app/sales/requests/requests-form.service';
import { ConfirmDeactivateGuard, SalesRoutingModule } from '@app/sales/sales-routing.module';
import { SalesListComponent } from './sales/sales-list/sales-list.component';
import { SalesFormComponent } from './sales/sales-form/sales-form.component';
import { SalesViewComponent } from './sales/sales-view/sales-view.component';
import { SalesRequestsFormComponent } from './sales/sales-requests-form/sales-requests-form.component';
import { SalesRequestsFormService } from '@app/sales/sales/sales-requests-form.service';
import { SalesOffersFormComponent } from './sales/sales-offers-form/sales-offers-form.component';
import { SalesFinalFormComponent } from './sales/sales-final-form/sales-final-form.component';
import { SaleGuestNamesFormComponent } from './sales/sale-guest-names-form/sale-guest-names-form.component';
import { SaleFinalsGuestNamesFormComponent } from './sales/sale-finals-guest-names-form/sale-finals-guest-names-form.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { WebOffersFormComponent } from './web-offers/web-offers-form/web-offers-form.component';
import { GuestNamesListComponent } from './guest-names-list/guest-names-list.component';
import { SalesOffersOnlineBookingTermsComponent } from './sales/sales-offers-online-booking-terms/sales-offers-online-booking-terms.component';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@NgModule({
  declarations: [
    RequestsListComponent,
    RequestsFormComponent,
    SalesListComponent,
    SalesFormComponent,
    SalesViewComponent,
    SalesRequestsFormComponent,
    SalesOffersFormComponent,
    SalesFinalFormComponent,
    SaleGuestNamesFormComponent,
    SaleFinalsGuestNamesFormComponent,
    WebOffersFormComponent,
    GuestNamesListComponent,
    SalesOffersOnlineBookingTermsComponent,
  ],
  imports: [CommonModule, SalesRoutingModule, SharedModule, GridModule, NumericTextBoxComponent],
  providers: [RequestsService, RequestsFormService, SalesRequestsFormService, KendoGridService, ConfirmDeactivateGuard],
})
export class SalesModule {}
